import { QuerySearchSalaryArgs } from '@/lib/generated/graphql-types'
import { parseToNumber } from '@/lib/strings'

import { SalaryFilterParam } from '../constants'
import { getSalaryHistogramInput } from '@/modules/salary/common/get-salary-histogram-input'
import { SalaryPayPeriod } from '../table/constants'

export function getSearchSalariesInput({
  jobType,
  occupationSlug,
  location,
  searchParams,
  hasInteractedWithRow,
}: {
  searchParams?: URLSearchParams | null
  jobType: string | undefined
  occupationSlug: string | undefined
  location: string | undefined
  hasInteractedWithRow?: boolean
}) {
  const featuredSalaryId = searchParams?.get(SalaryFilterParam.salaryId)
  const payPeriod = searchParams?.get(SalaryFilterParam.payPeriod)
  const sortBy = searchParams?.get(SalaryFilterParam.sortBy)
  const input: QuerySearchSalaryArgs['input'] = {
    ...getSalaryHistogramInput({
      jobType,
      occupationSlug,
      location,
    }),
    pageNumber: Math.max(
      1,
      parseToNumber(searchParams?.get(SalaryFilterParam.page) || '1'),
    ),
    pageSize: 20,
  }
  if (featuredSalaryId && !hasInteractedWithRow) {
    input.featuredId = featuredSalaryId
  }
  if (payPeriod) {
    input.payPeriod = payPeriod as SalaryPayPeriod
  }
  if (sortBy) {
    input.sortBy = sortBy
  }
  return input
}
